import MmcwArrow from '@propertypal/shared/src/resources/images/mmw/MMW-pink-arrow.svg';
import MmcwLogo from '@propertypal/shared/src/resources/logos/millar-mccall-wylie-logo.svg';
import { MILLAR_MCCALL_WYLIE } from '@propertypal/shared/src/styles/theme';
import Button from '@propertypal/web-ui/src/buttons/Button';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import { AdText, Container, Content, DeviceImages, WideContainer } from './MillarMcCallWylieAd.style';

interface Props {
  slots: number;
}

const MillarMcCallWylieAd: FunctionComponent<Props> = (props) => {
  if (props.slots === 2) {
    return (
      <WideContainer data-testid="mmcw-wide-ad">
        <div>
          <MmcwLogo style={{ height: 82 }} />

          <h2>
            Buying or selling <span>your home?</span>
          </h2>

          <AdText>
            Get instant legal fee estimates with the <b>NEW</b> legal calculator in partnership with leading local law
            firm Millar McCall Wylie.
          </AdText>

          <Link href="/legal-fees-calculator">
            <Button color={MILLAR_MCCALL_WYLIE} containerStyle={{ maxWidth: 320 }}>
              Calculate Legal Fees
            </Button>
          </Link>
        </div>

        <DeviceImages>
          <MmcwArrow />
        </DeviceImages>
      </WideContainer>
    );
  }

  return (
    <Container>
      <Content>
        <MmcwLogo style={{ height: 82 }} />

        <h2>
          Buying or selling <span>your home?</span>
        </h2>

        <p>
          Get instant legal fee estimates with the <b>NEW</b> legal calculator in partnership with leading local law
          firm Millar McCall Wylie.
        </p>

        <DeviceImages $small>
          <MmcwArrow viewBox="0 0 91 74" />
        </DeviceImages>

        <Link href="/legal-fees-calculator">
          <Button color={MILLAR_MCCALL_WYLIE}>Calculate Legal Fees</Button>
        </Link>
      </Content>
    </Container>
  );
};

export default MillarMcCallWylieAd;
